import { render, staticRenderFns } from "./Irradiate.vue?vue&type=template&id=313dcdb8&scoped=true&"
import script from "./Irradiate.vue?vue&type=script&lang=js&"
export * from "./Irradiate.vue?vue&type=script&lang=js&"
import style0 from "./Irradiate.vue?vue&type=style&index=0&id=313dcdb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313dcdb8",
  null
  
)

export default component.exports